export default "__VITE_ASSET__cTqmcFks__"